<template>
  <div ref="chartEl" style="min-height: 400px;" class="echart"></div>
</template>

<script setup>
import {computed, onMounted, onBeforeUnmount, ref, watch} from 'vue';
import {getCurrencyFormatted} from "@/api/helpers";

const props = defineProps({
  currency: String,
  elements: {type: Array, default: () => []},
});

const chartEl = ref(null);
let chart = null;

const chartValues = computed(() =>
    (props.elements || [])
    .map(el => ({
      value: Number(el.amount ?? 0),
      name: el.name ?? 'Без категории',
    }))
    .sort((a, b) => b.value - a.value)
);

function render() {
  if (!chart || !chartEl.value) return;

  chart.setOption({
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        return `
          ${params.marker}
          <strong>${params.name}</strong><br/>
          ${getCurrencyFormatted(params.value, props.currency)}
        `;
      }
    },
    legend: {top: '5%', left: 'center'},
    series: [{
      name: "",
      type: 'pie',
      radius: ['40%', '70%'],
      avoidLabelOverlap: false,
      label: {show: false, position: 'center', formatter: '{b}: {d}%',},
      emphasis: {
        label: {show: true, fontSize: 18, fontWeight: 'bold',  formatter: '{d}%',}
      },
      labelLine: {show: false},
      data: chartValues.value,
    }],
  }, true);
}

onMounted(() => {
  chart = echarts.init(chartEl.value);
  render();
});
watch(chartValues, () => {
  render();
});

onBeforeUnmount(() => {
  if (chart) {
    chart.dispose();
    chart = null;
  }
});
</script>
